import React from "react"
import autobind from "class-autobind"
import { IScheduleTemplate, IJobDocument} from "../../../../models"
import strings from "../../../../localization/strings"
import { TextField, Toggle } from "material-ui"
import ChooseHierarchyJobChip from "../../../../components/hierarchy/choose_hierarchy/ChooseHierarchyJobChip"
import { grey100 } from "material-ui/styles/colors"
import * as AccountActions from "../../../../actions/AccountActions"
import AccountStore from "../../../../stores/AccountStore"
import * as permissionHelper from "../../../../helpers/permissionHelper"
import AuthenticationStore from "../../../../stores/AuthenticationStore"
import * as scheduleHelper from "../../../../helpers/scheduleHelper"
import * as utils from "../../../../helpers/utils"
interface IProps {
  scheduleTemplate: IScheduleTemplate
}
interface IState {
  name: string
  errorName: string
  description: string
  hierarchyId: string
  jobId: string
  jobName: string
  periodDays: number
  errorPeriodDays: string
  excludeWeekends: boolean
}

export default class ScheduleTemplateInfoDetail extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      name: this.props.scheduleTemplate.Name,
      errorName: "",
      description: props.scheduleTemplate.Description,
      hierarchyId: props.scheduleTemplate.HierarchyId,
      jobId: props.scheduleTemplate.JobId,
      jobName: props.scheduleTemplate.JobName,
      periodDays: scheduleHelper.getDayLengthFromStartAndEndTime(props.scheduleTemplate.StartDate, props.scheduleTemplate.EndDate),
      errorPeriodDays: "",
      excludeWeekends: props.scheduleTemplate.ExcludeWeekends
    }
    autobind(this)
  }

  checkValidate() {
    let isValidate = true
    if (this.state.name.trim() === "") {
      this.setState({ errorName: strings.This_field_is_required })
      isValidate = false
    }
    else {
      this.setState({ errorName: "" })
    }

    if (!this.state.periodDays) {
      this.setState({ errorPeriodDays: strings.This_field_is_required })
      isValidate = false
    }
    else {
      const dayLengthFromPatternTempaltes = scheduleHelper.getDayLengthFromPatternTemplates(this.props.scheduleTemplate.StartDate, this.props.scheduleTemplate.PatternTemplates)
      if (this.state.periodDays < dayLengthFromPatternTempaltes || this.state.periodDays > 31) {
        this.setState({ errorPeriodDays: strings.formatString(strings.This_field_requires_a_number_between_min_and_max, dayLengthFromPatternTempaltes, 31) as string })
        isValidate = false
      }
      else {
        this.setState({ errorPeriodDays: "" })
      }
    }
    return isValidate
  }

  handleUpdate() {
    if (!this.checkValidate()) return
    const { scheduleTemplate } = this.props
    scheduleTemplate.Name = this.state.name
    scheduleTemplate.Description = this.state.description
    scheduleTemplate.HierarchyId = this.state.hierarchyId
    scheduleTemplate.JobId = this.state.jobId
    scheduleTemplate.JobName = this.state.jobName
    scheduleTemplate.StartDate = scheduleHelper.getTimeFromSimpleTime(AccountStore.ScheduleVirtualSimpleTime).utc(true).format()
    scheduleTemplate.EndDate = scheduleHelper.getTimeFromSimpleTime(AccountStore.ScheduleVirtualSimpleTime).add(this.state.periodDays - 1, "day").endOf("day").utc(true).format()
    scheduleTemplate.ExcludeWeekends = this.state.excludeWeekends
    AccountActions.updateScheduleTemplate(AccountStore.getCurrentAccount().Id, scheduleTemplate)
  }

  render() {
    return (
      <div style={{ display: "flex" }}>
        <div style={{ display: "flex", flex: 1, alignItems: "center", justifyContent: "center", fontSize: 23, fontWeight: 600 }}>{strings.Schedule_Template}</div>
        <div style={{ flex: 3, backgroundColor: grey100 }}>
          <div style={{ padding: "15px 50px" }}>
            <div style={{ width: "75%", display: "flex" }}>
              <TextField
                data-intercom-target={"ScheduleTemplates-InfoDetails-Entry-Name"}
                floatingLabelText={strings.Name}
                value={this.state.name}
                onChange={(e, value) => { this.setState({ name: value }, () => this.handleUpdate()) }}
                errorText={this.state.errorName}
                errorStyle={{ position: "absolute", bottom: -10 }}
                fullWidth={true}
                disabled={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditAccountSchedule)}
              />
              <TextField
                data-intercom-target={"ScheduleTemplates-InfoDetails-Entry-SchedulePeriodDays"}
                floatingLabelText={strings.Schedule_Period_Days}
                value={this.state.periodDays}
                onChange={(e, value) => utils.validateInteger(value) && this.setState({ periodDays: value }, () => this.handleUpdate())}
                errorText={this.state.errorPeriodDays}
                errorStyle={{ position: "absolute", bottom: -10 }}
                style={{ width: 175, marginLeft: 25 }}
                disabled={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditAccountSchedule)}
              />
            </div>
            <div style={{ width: "75%" }}>
              <TextField
                data-intercom-target={"ScheduleTemplates-InfoDetails-Entry-Description"}
                floatingLabelText={strings.Description}
                value={this.state.description}
                onChange={(e, value) => { this.setState({ description: value }, () => this.handleUpdate()) }}
                fullWidth={true}
                disabled={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditAccountSchedule)}
              />
            </div>
            <Toggle
              data-intercom-target={"ScheduleTemplates-InfoDetails-Toggle-ExcludeWeekends"}
              label={strings.Exclude_Weekends}
              toggled={this.state.excludeWeekends}
              style={{ width: 225, marginTop: 25 }}
              onToggle={(e, value) => this.setState({ excludeWeekends: value }, () => this.handleUpdate())}
              disabled={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditAccountSchedule)}
            />
            <div style={{ marginTop: 20 }}>
              <ChooseHierarchyJobChip
                readonlyHierarchy
                readonlyJob
                hideJob={!AccountStore.getJobsEnabled()}
                hierarchyChipLabel={strings.HierarchyLevel}
                jobChipLabel={strings.Job}
                hierarchyItemId={this.state.hierarchyId}
                jobId={this.state.jobId}
                hieararchyChipMaxWidth={700}
                jobChipMaxWidth={700}
                handleSelectHierarchyJob={(hierarchyItemId: string, job: IJobDocument) => {
                  this.setState({ jobId: job ? job.Id : null, jobName: job ? job.Name : null }, () => this.handleUpdate())
                }}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}